import React from 'react';

const baseButtonClass =
  'px-5 flex items-center justify-center text-base font-bold tracking-wide uppercase transition-colors duration-150 border border-transparent';

/**
 * Reusable filter control for either a select dropdown or segmented button group.
 *
 * @param {Object} props
 * @param {string} props.label
 * @param {'select'|'button-group'} props.controlType
 * @param {string} props.value
 * @param {{label: string, value: string}[]} props.options
 * @param {(value: string) => void} props.onChange
 * @param {string} [props.name]
 * @param {string} [props.wrapperClassName]
 * @param {string} [props.labelClassName]
 * @param {string} [props.controlClassName]
 */
export const FilterControl = ({
  label,
  controlType,
  value,
  options = [],
  onChange,
  name,
  wrapperClassName = '',
  labelClassName = '',
  controlClassName = '',
}) => {
  return (
    <div className={`w-full sm:w-fit ${wrapperClassName}`.trim()}>
      <label
        className={`mb-2 block text-xs font-bold tracking-[0.2em] uppercase text-stone-600 ${labelClassName}`.trim()}
      >
        {label}
      </label>

      {controlType === 'select' ? (
        <div className={`relative w-full sm:w-fit ${controlClassName}`.trim()}>
          <select
            name={name}
            aria-label={label}
            value={value}
            onChange={(event) => onChange(event.target.value)}
            className="h-8 w-full bg-white px-4 text-base font-bold uppercase tracking-wide text-stone-700 outline-none ring-1 ring-stone-300 transition focus:ring-red-200 sm:w-auto leading-8"
          >
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      ) : (
        <div
          className={`grid h-8 w-full grid-cols-1 gap-0 bg-gray-100 p-0 ring-1 ring-stone-300 sm:inline-flex ${controlClassName}`.trim()}
          role="group"
          aria-label={label}
        >
          {options.map((option) => {
            const isActive = option.value === value;
            return (
              <button
                key={option.value}
                type="button"
                className={`${baseButtonClass} ${isActive ? 'bg-red-500 text-white border-red-100' : 'bg-gray-100 text-stone-700 border-stone-300 hover:bg-white'}`.trim()}
                onClick={() => onChange(option.value)}
              >
                {option.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FilterControl;
